// Promise.withResolvers (Safari 17.4, Chrome 119) for older browsers: pdf.js calls it to start the PDF preview, and
// without it iOS 16 and older Android browsers showed a blank page (Sentry WEB-APP-669)
if (typeof (Promise as PromiseConstructor & { withResolvers?: unknown }).withResolvers !== 'function') {
  Object.defineProperty(Promise, 'withResolvers', {
    configurable: true,
    writable: true,
    value: function withResolvers<T>() {
      let resolve!: (value: T | PromiseLike<T>) => void;
      let reject!: (reason?: unknown) => void;
      const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve, reject };
    },
  });
}

export {};
